import slidePhoto1 from '../../../shared/assets/photo/slider/1.jpg';
import slidePhoto2 from '../../../shared/assets/photo/slider/2.jpg';
import slidePhoto3 from '../../../shared/assets/photo/slider/3.jpg';
import slidePhoto4 from '../../../shared/assets/photo/slider/4.jpg';
import slidePhoto5 from '../../../shared/assets/photo/slider/5.jpg';
import slidePhoto6 from '../../../shared/assets/photo/slider/6.jpg';


export const sliderData = [
    {
        id: 1,
        slide: slidePhoto1
    },
    {
        id: 2,
        slide: slidePhoto2
    },
    {
        id: 3,
        slide: slidePhoto3
    },
    {
        id: 4,
        slide: slidePhoto4
    },
    {
        id: 5,
        slide: slidePhoto5
    },
    {
        id: 6,
        slide: slidePhoto6
    },
];